jQuery(document).ready(function($) {
    const $blocks = $('.wp-block-jormi-blocks-immersive-section');
    
    if ($blocks.length === 0 || typeof ScrollTrigger === 'undefined') return;

    gsap.registerPlugin(ScrollTrigger);

    $blocks.each(function() {
        const $block = $(this);
        const $timelinePhotoWrapper = $block.find('.timeline-photo-wrapper');

        // Timeline navigation animations
        gsap.timeline({
            scrollTrigger: {
                trigger: $block.find('.timeline')[0],
                start: 'top bottom-=200px',
                end: '+=500',
                scrub: true
            }
        })
        .to($block.find('.timeline'), { opacity: 1 })
        .to($block.find('.timeline-nav'), { top: '25vh' })
        .to($block.find('.timeline-nav li:first-child'), { opacity: 1 });

        gsap.timeline({
            scrollTrigger: {
                trigger: $block.find('.timeline-content2')[0],
                start: 'top bottom-=200px',
                end: '+=500',
                scrub: true
            }
        })
        .to($block.find('.timeline-nav li:first-child'), { opacity: 0.2 })
        .to($block.find('.timeline-nav li:nth-child(2)'), { opacity: 1 });

        gsap.timeline({
            scrollTrigger: {
                trigger: $block.find('.timeline-content3')[0],
                start: 'top bottom-=200px',
                end: '+=500',
                scrub: true
            }
        })
        .to($block.find('.timeline-nav li:nth-child(2)'), { opacity: 0.2 })
        .to($block.find('.timeline-nav li:nth-child(3)'), { opacity: 1 });

        gsap.timeline({
            scrollTrigger: {
                trigger: $block.find('.timeline-content4')[0],
                start: 'top bottom-=200px',
                end: '+=500',
                scrub: true
            }
        })
        .to($block.find('.timeline-nav li:nth-child(3)'), { opacity: 0.2 })
        .to($block.find('.timeline-nav li:nth-child(4)'), { opacity: 1 });

        gsap.timeline({
            scrollTrigger: {
                trigger: $block.find('.timeline')[0],
                start: 'bottom center',
                end: '+=500',
                scrub: true
            }
        })
        .to($block.find('.timeline'), { opacity: 0 })
        .to($block.find('.timeline-nav li'), { opacity: 0.2 });

        // Photo animations - independent triggers
        for (let i = 1; i <= 4; i++) {
            const content = $block.find(`.timeline-content${i}`)[0];
            const photo = $timelinePhotoWrapper.find(`.timeline-photo${i}`)[0];

            if (content && photo) {
                gsap.set(photo, { opacity: 0 });
                
                ScrollTrigger.create({
                    trigger: content,
                    start: "center bottom",
                    end: "center top",
                    onToggle: (self) => {
                        gsap.to(photo, {
                            opacity: self.isActive ? 1 : 0,
                            duration: 0.5
                        });
                    }
                });
            }
        }
    });
});